"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reactResponsive = require("react-responsive");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var defaults = {
  desktop: false,
  tablet: false,
  mobile: false
};

var Responsive = function Responsive(_ref) {
  var children = _ref.children;
  var isLargeDesktop = (0, _reactResponsive.useMediaQuery)({
    minWidth: 1200
  });
  var isDesktop = (0, _reactResponsive.useMediaQuery)({
    minWidth: 992
  });
  var isTablet = (0, _reactResponsive.useMediaQuery)({
    minWidth: 768
  });

  if (isLargeDesktop) {
    return children(_objectSpread({}, defaults, {
      desktop: true,
      large: true
    }));
  } else if (isDesktop) {
    return children(_objectSpread({}, defaults, {
      desktop: true
    }));
  } else if (isTablet) {
    return children(_objectSpread({}, defaults, {
      tablet: true
    }));
  } else {
    // Anything smaller is mobile.
    return children(_objectSpread({}, defaults, {
      mobile: true
    }));
  }
};

var _default = Responsive;
exports["default"] = _default;